'use client'

import Footer from "./footer"
import Header from "./header"
import React, {useEffect} from "react";
import NavigationBar from "./navbar";


export default function Layout({children}) {
    const [active, setActive] = React.useState(false);

    useEffect(() => {
        const template = location.pathname

        if (template === '/' || template === '/login' || template === '/forgot-password' || template === '/engine-redirect' || template === '/submit-extension') {
            setActive(false)
        } else {
            setActive(template)
        }
    }, [])

    return (

        <div className='layout'>
            <Header/>
                {active ? <NavigationBar active={active}/> : null}
                {children}
            <Footer/>
        </div>
    )
}
